import { CardCodes } from '@revenuemarket/bank';

import { API } from '~apis/axios/instance';
import { TaxInvoiceType } from '~models/tax-invoice';
import { ResponseBaseWithData } from '~types/response';

export interface MappingRequest {
  companyId: string;
  transactionId: number;
  labelId: number;
}

export interface TaxInvoiceMapping {
  id: string;
  companyId: string;
  type: TaxInvoiceType;
  content: IContent;
  createdAt: string;
  reportingDate: string;
  issueDate: string;
  supplyValue: number;
  totalAmount: number;
  vatTaxation: boolean;
  contractorRegNumber: string;
  contractorCompanyName: string;
  supplierRegNumber: string;
  supplierCompanyName: string;
  counterPartyCompanyName: string;
  counterPartyRegNumber: string;
  counterPartyName: string;
  originalInvoiceId: string;
  counterPartyBusinessPlace: string;
  counterPartyBusinessType: string;
}
interface IContent {
  reportingDate: string;
  approvalNo: string;
  issueDate: string;
  sendDate: string;
  supplyValue: string;
  taxAmt: string;
  etaxInvoiceType: string;
  issueNm: string;
  note: string;
  repItems: string;
  itemList: IItemListItem[];
  supplierRegNumber: string;
  supplierEstablishNo: string;
  supplierCompanyName: string;
  supplierName: string;
  supplierBusinessPlace: string;
  supplierBusinessTypes: string;
  supplierBusinessItems: string;
  email: string;
  contractorRegNumber: string;
  contractorEstablishNo: string;
  contractorCompanyName: string;
  contractorName: string;
  contractorBusinessPlace: string;
  contractorBusinessTypes: string;
  contractorBusinessItems: string;
  email1: string;
  email2: string;
  trusteeRegNumber: string;
  trusteeEstablishNo: string;
  trusteeCompanyName: string;
  trusteeName: string;
  trusteeBusinessPlace: string;
  trusteeBusinessTypes: string;
  trusteeBusinessItems: string;
  trusteeEmail: string;
  importDeclarationNo: string;
  commStartDate: string;
  commEndDate: string;
  totalCount: string;
  totalAmount: string;
  reasonModification: string;
  cash: string;
  check: string;
  bankBill: string;
  accountReceivable: string;
  receiptOrCharge: string;
}
interface IItemListItem {
  purchaseExpiryDate: string;
  taxItemName: string;
  standards: string;
  quantity: string;
  unitPrice: string;
  supplyValue: string;
  taxAmt: string;
  note: string;
}

export const getTaxInvoiceMapping = ({ companyId, transactionId, labelId }: MappingRequest) => {
  return API.get<ResponseBaseWithData<{ items: TaxInvoiceMapping[] }>>(
    `/api/v2/companies/${companyId}/bank-transactions/${transactionId}/labels/${labelId}/documents/tax-invoice`,
  );
};

interface CardMapping {
  approvalNo: string;
  organizationCode: CardCodes;
  organizationName: string;
  companyId: string;
  cardNo: string;
  currency: string;
  usedAmount: number;
  krwAmount: number;
  canceledAmount: number;
  cancelType: string;
  homeForeignType: string;
  paymentType: string;
  fee: number;
  vat: number;
  cashBack: number;
  installmentMonth: number;
  memberStoreAddr: string;
  memberStoreName: string;
  memberStoreNo: string;
  memberStoreCorpNo: string;
  memberStoreType: string;
  memberStoreTelNo: string;
  paymentDueDate: string;
  usedAt: string;
  createdAt: string;
  updatedAt: string;
}

export const getCardMapping = ({ companyId, transactionId, labelId }: MappingRequest) => {
  return API.get<ResponseBaseWithData<{ items: CardMapping[] }>>(
    `/api/v2/companies/${companyId}/bank-transactions/${transactionId}/labels/${labelId}/documents/check-card`,
  );
};

interface CashRecieptMapping {
  id: string;
  usedDateTime: string;
  companyId: string;
  resApprovalNo: string;
  resUsedDate: string;
  resUsedTime: string;
  resTransTypeNm: string;
  resIssueType: string | null;
  resSupplyValue: string;
  resVat: string;
  resTip: string;
  resIdMeans: string;
  resTotalAmount: string;
  resCompanyIdentityNo: string;
  resCompanyNm: string;
}

export const getCashReceiptMapping = ({ companyId, transactionId, labelId }: MappingRequest) => {
  return API.get<ResponseBaseWithData<{ items: CashRecieptMapping[] }>>(
    `/api/v2/companies/${companyId}/bank-transactions/${transactionId}/labels/${labelId}/documents/cash-receipt`,
  );
};

interface DeleteMappingRequest {
  companyId: string;
  transactionId: number;
  labelId: number;
}
export const deleteMappings = ({ companyId, transactionId, labelId }: DeleteMappingRequest) => {
  return API.delete(
    `/api/v2/companies/${companyId}/bank-transactions/${transactionId}/mappings/transaction-labels/${labelId}`,
  );
};
